<template>
  <div class="slide" id="thanks" v-show="isVisibleSlide('thanks')">
    <div class="container">
      <h2>Thanks for signing! Will you ask your MP to support the campaign for assisted dying too?</h2>
      <p>To make assisted dying legal, we need the support of as many MPs as possible. We know that hearing real stories and experiences from constituents will help get them on board - so {{ $store.state.user.firstname }}, will you take a moment to leave them a message about why you support the campaign?</p>
      <div class="button_wrap">
        <button @click="gotoSlide('tell-your-mp'), analytics('ask_mp', 'yes')" class="pink">Yes</button>
        <button @click="gotoSlide('will-share'), analytics('ask_mp', 'no')" class="grey">No</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Thanks",
  props: ["gotoSlide", "isVisibleSlide", "analytics"]
};
</script>

